module.exports = __webpack_public_path__ + "static/sign-up-d8316a6954110319d7ee48612f7d9b21.png";